module.exports = __webpack_public_path__ + "img/Richie_Hawtin.dde85e66.jpg";